var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column box is-three-fifths is-offset-one-fifth content"},[_c('div',{staticClass:"section content"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }